<template>
	<div>
		<a href="#!" class="btn btn-sm effect-zoom" v-tooltip="'Eliminar'" v-on:click.prevent="destroy()">
			<i class="material-icons">delete</i>
		</a>
	</div>
</template>
<script>
	export default{
		props: {
            url: String,
        },

        computed: {
            urlDelete: function () {
                return this.url;
            },
        },

        methods: {
        	destroy: function(){
        		var $module = this;

        		$.confirm({
			        title: '¿Estás seguro?',
			        content: '¡Ya no podrás recuperar esta información!',
			        theme: 'supervan', // 'material', 'bootstrap'
			        buttons: {
			            Confirmar: function () {
			                axios.delete($module.urlDelete)
			                    .then(response => {
			                        location.reload();
			                        Vue.toasted.show('Eliminado');
			                    })
			                    .catch(error => {
			                        //modules.$toasted.show('Error al eliminar');
			                        Vue.toasted.show('Error al Eliminar');
			                        console.log(error.response);
			                    });
			            },
			            Cancelar: function () {
			            },
			        }
			    });
        	}
        }
	}
</script>